import { createReactive } from "@supergrain/kernel"

/**
 * The course the month sidebar is focused on — the one whose lesson should be in view.
 *
 * Module-scoped because the lesson slots are separate React roots in one Vite bundle: module scope
 * is the only thing that crosses roots (React context cannot). supergrain `createReactive`, never
 * `useSyncExternalStore` (precedent: lesson-drag-session.ts).
 *
 * Written where focus actually changes — the month's own actions — rather than mirrored down
 * through component args, so there is one write per real event and no arg to thread through the
 * planner's templates.
 */
const state = createReactive<{ courseId: string | null }>({ courseId: null })

/** Read the focused course (reactive: subscribes the reading `tracked` component). */
export function focusedCourseId(): string | null {
  return state.courseId
}

/** Focus a course's lesson, or clear the focus with `null`. */
export function focusCourse(courseId: string | null): void {
  state.courseId = courseId
}
